import React from 'react';
import NextLink from 'next/dist/client/link';

import { ItemLink, LetterBlock, Text } from './letter.styles';
import { iLetter } from './letter.types';

interface LetterProps {
  letter: iLetter;
  baseUrl: string;
}

export const Letter = ({ letter: { initial, data }, baseUrl }: LetterProps) => (
  <LetterBlock key={initial}>
    <Text>{initial}</Text>
    {data.map(({ slug, name }, index) => (
      <NextLink key={`${index}`} href={`/${baseUrl}/${slug}`} passHref>
        <ItemLink>{name}</ItemLink>
      </NextLink>
    ))}
  </LetterBlock>
);
